import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Form, Button, Alert } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { IconCirclePlusFilled, IconTrash, IconDownload } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { updateProfile, userStore } from "../../../redux/reduxStore.js";
import { toast } from 'react-toastify';
import Loader from '../../Loader.jsx';
import useDownloader from 'react-use-downloader';
import { FileIcon, defaultStyles } from 'react-file-icon';
import DeleteUserCompany from './Modal/DeleteCompany.jsx';

const Userprofile = () => {
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const [loader, setLoader] = useState(false);
  const { download } = useDownloader();
  const [deleteCompany, setDeleteCompany] = useState(false);
  const [delCompanyName, setDelCompanyName] = useState(null);
  const [delCompanyDocument, setDelCompanyDocument] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: {
      firstName: user.userName?.split(" ")[0],
      lastName: user.userName?.split(user.userName?.split(" ")[0])[1],
      phone: user.phone,
      country: user.country
    }
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    reset: reset2
  } = useForm({
    defaultValues: {
      companyName: null,
      companyDocument: null
    }
  });

  const addCompanyDetails = (data) => {
    const Data = new FormData();
    Data.append("companyName",data.companyName);
    Data.append("document", data.companyDocument?.[0]);
    setLoader(true);
    axios({
      method:"POST",
      url:`${process.env.REACT_APP_BASE_URL}/user/company/${user._id}`,
      headers:{
        "Content-Type":"multipart/form-data",
        "Authorization":`Bearer ${token}`
      },
      data: Data,
    }).then(res => {
      userStore.dispatch(updateProfile({ companies:res.data.companies }));
      setLoader(false);
      reset2({ companyDocument:null, companyName:null });
      toast(res?.data?.message, {
        type:"success",
        theme:"light",
        position:"top-right"
      })
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg,{
          theme:"light",
          type:"error",
          position:"top-right"
        });
      } else {
        toast(err?.response?.data?.message || err?.message || "Failed to add company",{
          theme:"light",
          type:"error",
          position:"top-right"
        });
      }
    });
  }

  const updateUserProfile = (data) => {
    setLoader(true);
    axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}/user/${user._id}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      data: {
        userName: `${data.firstName.trim()} ${data.lastName}`,
        phone: data.phone,
        country: data.country
      }
    }).then(res => {
      userStore.dispatch(updateProfile({ userName: `${data.firstName.trim()} ${data.lastName}`, phone: data.phone, country: data.country }));
      setLoader(false);
      reset(data);
      toast(res.data.message, {
        theme: "light",
        position: "top-right",
        type: "success"
      });
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Failed to update profile", {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      }
    });
  }

  const handleStatus = (status) => {
    if (status === "Approve") {
      return (<small className='text-success'>{status}</small>);
    } else if (status === "Rejected") {
      return (<small className='text-danger'>{status}</small>);
    } else {
      return (<small className='text-info'>{status}</small>);
    }
  }

  return (
    <>
      <section className='form-section userform user_main'>
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className='mb-5'>
              <div className="boxwrap">
                  <div className="head">
                    { !user.kyc ?
                    <>
                    <div className="d-flex align-content-center justify-content-between">
                      <h2 className='text-gradient'>let's verify KYC</h2>
                      <Link to={'/kyc'} className='button text-decoration-none blue align-self-center'>KYC</Link>
                    </div>
                    <p className="mb-0">Your account is pending KYC verification. Please click the "KYC" button to proceed with the verification process.</p>
                    </>
                    : <Alert key="success" variant="success" className='m-0'>
                      Your KYC process has been successfully completed. Thank you for verifying your account.
                    </Alert> }
                </div>
              </div>
            </Col>
            
            <Col lg={10} className='mb-5'>
              <div className="boxwrap">
                <h2 className='text-gradient'>My Profile</h2>
                <div className="row">
                  <Form.Group as={Col} md="6" className="mb-3" controlId="up-firstname">
                    <Form.Label>First Name <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      {...register("firstName", {
                        required: { value: true, message: "First name is require" },
                        minLength: { value: 2, message: "First name is not valid" }
                      })} />
                    {errors.firstName ? <p className='errMsg'>{errors.firstName.message}</p> : null}
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="mb-3" controlId="up-lastname">
                    <Form.Label>Last Name <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      {...register("lastName", {
                        required: { value: true, message: "Last name is require" },
                        minLength: { value: 2, message: "Last name in not valid" }
                      })} />
                    {errors.lastName ? <p className='errMsg'>{errors.lastName.message}</p> : null}
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="up-emailaddress">
                    <Form.Label>Email Address <span>*</span></Form.Label>
                    <Form.Control disabled type="mail" placeholder="Email Address" value={`${user.email}`} />
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="up-phonenumber">
                    <Form.Label>Phone Number <span>*</span></Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Phone Number"
                      {...register("phone", {
                        required: { value: true, message: "Phone number is require" },
                        pattern: { message: 'Phone number is not valid', value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/g }
                      })} />
                    {errors.phone ? <p className='errMsg'>{errors.phone.message}</p> : null}
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="up-phonenumber">
                    <Form.Label>Country <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter country name"
                      {...register("country", {
                        required: { value: true, message: "Country name is require" },
                      })} />
                    {errors.country ? <p className='errMsg'>{errors.country.message}</p> : null}
                  </Form.Group>

                  <div className="d-flex align-items-center justify-content-end gap-3">
                    <Button disabled={!isDirty} onClick={handleSubmit(updateUserProfile)} type="submit" className="button blue py-3">Update</Button>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={10}>
              <div className="boxwrap">
                <h2 className='text-gradient'>Add Company</h2>
                <p className="mb-3">You can add only three company details.</p>
                <Form onSubmit={handleSubmit2(addCompanyDetails)}>
                  <Row className="align-items-end">
                    <Form.Group as={Col} md="12" className="flex-grow-1 mb-3" controlId="up-firstname">
                      <Form.Label>Company Name <span>*</span></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Company name"
                        {...register2("companyName", {
                          required: { value: true, message: "Company name is require" },
                        })} />
                      {errors2.companyName ? <p className='errMsg'>{errors2.companyName.message}</p> : null}
                    </Form.Group>
                    <Form.Group as={Col} md="12" className="flex-grow-1 mb-3" controlId="up-lastname">
                      <Form.Label>Company Details<span>*</span></Form.Label>
                      <Form.Control
                        type="file" placeholder="Document"
                        {...register2("companyDocument", {
                          required: { message: "Document is require", value: true },
                          validate: {
                            size: (file) => {
                              return file?.[0]?.size <= 2 * 1024 * 1024 || "File size exceeds 2MB"
                            }
                          }
                        })} />
                      {errors2.companyDocument ? <p className='errMsg'>{errors2.companyDocument.message}</p> : null}
                    </Form.Group>
                    <Col md={12}>
                      <div className="d-flex align-items-center justify-content-end gap-3 flex-grow-1">
                        <Button disabled={user?.companies?.length > 2 ? true : false} onClick={handleSubmit2(addCompanyDetails)} type="submit" className="button yellow">
                          <IconCirclePlusFilled size={24} /> Add Company</Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
                <Row className='mt-4'>
                  <Col md="12">
                    <div className="table-responsive">
                      {user?.companies?.length > 0 ?
                        <table className="client_table">
                          <thead>
                            <tr>
                              <th>Company Name</th>
                              <th>Company Details</th>
                              <th>Status</th>
                              <th className='text-end'>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {user.companies.map(p => {
                              return (
                                <tr>
                                  <td><small>{p?.name}</small></td>
                                  <td>
                                    <small className='d-flex align-items-center gap-2'>
                                      <div className="doc-file">
                                        <FileIcon extension={p?.document?.split('.')[1]} {...defaultStyles[p?.document?.split('.')[1]]} />
                                      </div>
                                      <button className='button yellow p-1 rounded-pill' onClick={() => download(`${process.env.REACT_APP_IMG_BASE_URL}${p?.document}`, p?.document?.split('company/')[1])}>
                                        <IconDownload size={20} stroke={2} />
                                      </button>
                                    </small>
                                  </td>
                                  <td>
                                    {handleStatus(p?.status)}
                                  </td>
                                  <td className='text-end'>
                                    <p>
                                      <Button
                                        disabled={p?.status === "Pending" ? false : true}
                                        onClick={() => {
                                          setDelCompanyName(p?.name);
                                          setDelCompanyDocument(p?.document);
                                          setDeleteCompany(true);
                                        }}
                                        className="button red pill rounded-circle p-1">
                                        <IconTrash size={24} stroke={2} />
                                      </Button>
                                    </p>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        : <p>Companies not found</p>}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader} />
      <DeleteUserCompany
      show={deleteCompany}
      companyName={delCompanyName}
      document={delCompanyDocument}
      onHide={() => setDeleteCompany(false)}/>
    </>
  )
}

export default Userprofile